module.exports = __webpack_public_path__ + "img/ring_g_e_0_1.43730f4c.png";